<template>
    <div class="stepper">
        <div class="stepper__scale" :style="{width: fillPercentage + '%'}"></div>
        <div class="stepper__item"
            v-for="(label, index) in labels"
            :class="{ 'stepper__item_active': index <= currentStep, 'stepper__item_current': index === currentStep }"
            :key="label">
            <span class="stepper__item-label">{{ label }}</span>
            <base-material-design-icon class="stepper__item-icon"
                icon="check" />
        </div>
    </div>
</template>

<script>
export default {
    name: 'stepper',
    props: {
        // Array of labels. Amount of steps defined by amount of labels
        labels: Array,
        currentStep: {
            type: Number,
            default: 0
        }
    },
    computed: {
        fillPercentage() {
            if (!this.labels.length) {
                return 0;
            }

            if (this.currentStep >= this.labels.length) {
                return 100;
            }
            return 100 / (this.labels.length - 1) * this.currentStep;
        }
    }
}
</script>
<style scoped
    lang="scss">
    .stepper {
        display: flex;
        justify-content: space-between;
        position: relative;
        padding-top: 34px;

        &::before,
        &__scale {
            display: block;
            position: absolute;
            top: 6px;
            left: 0;
            height: 2px;
        }

        &::before {
            content: '';
            width: 100%;
            background-color: $rfx-light-grey;
        }

        &__scale {
            background-color: $rfx-lighter-blue;
            transition: width .5s;
        }

        &__item {
            display: block;
            position: relative;
            margin-top: -34px;
            z-index: 1;
            width: 14px;
            height: 14px;
            border-radius: 50%;
            background-color: $rfx-light-grey;

            &_active {
                background-color: $rfx-lighter-blue;
            }

            &_current {
                .stepper__item-label {
                    opacity: 1;
                }
            }

            &_active:not(.stepper__item_current) {
                .stepper__item-icon {
                    opacity: 1;
                }
            }
        }

        &__item-label {
            position: absolute;
            top: 28px;
            left: 50%;
            transform: translateX(-50%);
            color: $rfx-light-green;
            opacity: 0;
        }

        &__item-icon {
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            top: -17px;
            font-size: 16px;
            color: $rfx-light-green;
            opacity: 0;
        }
    }
</style>